module.exports = __webpack_public_path__ + "static/media/sociallis-logo-hor2.3aeeb51d.png";